import React from 'react';
import {
  ChartPieSlice, ListChecks, CalendarBlank, ChartBar, Bank, Gear,
  UserCircle, SignOut, ChartLineUp, PlusCircle, Car, UsersThree,
} from '@phosphor-icons/react';

// IMPORTANT: admin tab list is hardcoded here for the sidebar. The routing
// list in App.js (`tabsByType.admin`) must stay in sync — otherwise a tab
// either renders nothing (defined here but not in App.js) or is unreachable
// (defined in App.js but not here).
const NAV_ITEMS = [
  { key: 'Dashboard',  icon: ChartPieSlice },
  { key: 'Jobs',       icon: ListChecks },
  { key: 'Log Job',    icon: PlusCircle },
  { key: 'Attendance', icon: CalendarBlank },
  { key: 'Reports',    icon: ChartBar },
  { key: 'Private',    icon: UsersThree },
  { key: 'Finance',    icon: Bank },
  { key: 'Settings',   icon: Gear },
];

export default function AdminShell({ user, currentTab, onTabChange, onAccount, onLogout, children, headerSlot, showMelville }) {
  // Melville integration nav item — only when the bridge is configured. Goes
  // in just above Settings, by name rather than by index so adding a nav item
  // above it can't silently move it.
  const navItems = [...NAV_ITEMS];
  if (showMelville) {
    navItems.splice(navItems.findIndex(n => n.key === 'Settings'), 0, { key: 'Detail Queue', icon: Car });
  }
  return (
    <div className="admin-v2">
      <div className="admin-v2-shell">
        {/* ── Sidebar ── */}
        <aside className="admin-v2-sidebar">
          <div className="admin-v2-sidebar-brand">
            <div className="admin-v2-sidebar-brand-icon">
              <ChartLineUp size={22} color="#0F2233" weight="bold" />
            </div>
            <div>
              <div className="admin-v2-sidebar-brand-title">Dashboard</div>
              <div className="admin-v2-sidebar-brand-sub">Acts Car Detailing</div>
            </div>
          </div>

          <nav className="admin-v2-nav">
            {navItems.map(({ key, icon: Icon }) => (
              <button
                key={key}
                className={`admin-v2-nav-btn${currentTab === key ? ' active' : ''}`}
                onClick={() => onTabChange(key)}
              >
                <Icon size={20} weight={currentTab === key ? 'fill' : 'regular'} />
                <span>{key}</span>
              </button>
            ))}
          </nav>

          <div className="admin-v2-sidebar-footer">
            <button className="logout" onClick={onAccount}>
              <UserCircle size={18} weight="duotone" />
              <span>My Account</span>
            </button>
            <button className="logout" onClick={onLogout}>
              <SignOut size={18} weight="regular" />
              <span>Logout</span>
            </button>
            <div style={{ marginTop: 10, paddingLeft: 4 }}>
              Signed in as<br />
              <strong style={{ color: '#fff' }}>{user?.name || user?.username}</strong>
            </div>
          </div>
        </aside>

        {/* ── Main content ── */}
        <main className="admin-v2-content">
          {/* Top bar — holds the workspace switcher (multi-customer). Only
              rendered when a headerSlot is supplied so non-admin layouts and
              the invoice view stay unaffected. */}
          {headerSlot && (
            <div style={{
              display: 'flex', alignItems: 'center', gap: 12,
              padding: '10px 4px 14px', marginBottom: 4,
            }}>
              {headerSlot}
            </div>
          )}
          {children}
        </main>
      </div>
    </div>
  );
}
